document.addEventListener('click', function(e) {
    try {
      var label = e.target.closest('label[data-option-value]');
      if (!label) return;
      var picker = label.closest('variant-picker');
      if (!picker) return;
      var formId = picker.getAttribute('form');
      var form = formId && document.getElementById(formId);
      if (!form) return;
      var masterInput = form.querySelector('input[name="id"]');
      if (!masterInput) return;
      var variants = (picker.product && picker.product.variants)
        || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta
            && window.ShopifyAnalytics.meta.product
            && window.ShopifyAnalytics.meta.product.variants);
      if (!variants || !variants.length) return;
      var clickedRadio = document.getElementById(label.getAttribute('for'));
      if (!clickedRadio) return;
      var clickedSelector = label.closest('[data-option-selector]');
      var optionSelectors = picker.querySelectorAll('[data-option-selector]');
      if (!optionSelectors.length) return;
      var selectedValues = [];
      for (var i = 0; i < optionSelectors.length; i++) {
        if (optionSelectors[i] === clickedSelector) {
          selectedValues.push(clickedRadio.value);
        } else {
          var other =
  optionSelectors[i].querySelector('input[type="radio"]:checked');
          if (!other) return;
          selectedValues.push(other.value);
        }
      }
      var title = selectedValues.join(' / ');
      var match = null;
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        if (v.options && v.options.every(function(o, k) { return o ===
  selectedValues[k]; })) { match = v; break; }
        if (!v.options && (v.public_title === title || v.title === title)) {
  match = v; break; }
      }
      if (match) {
        masterInput.value = String(match.id);
        masterInput.removeAttribute('disabled');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(match.id));
        window.history.replaceState({}, '', url.toString());
      }
    } catch(err) {}
  });